// extracted by mini-css-extract-plugin
export default {"in_stock_sign":"InStockSign-module__in_stock_sign--ajUVu"};